export const ALL_MODULES = [
  "batch",
  "content",
  "sessions",
  "students",
  "homework",
  "funnel",
  "crm",
  "ads",
  "webinar",
  "affiliate",
  "builder",
  "payments"
];

export const ALL_ACTIONS = [
  "create",
  "edit",
  "delete",
  "view",
  "publish",
  "manage",
  "restore",
  "duplicate",
  "unlock",
  "host"
];